package com.xtream.ui.data


import androidx.compose.ui.graphics.vector.ImageVector
import org.jetbrains.compose.resources.StringResource

// ── Base action interface ─────────────────────────────────────────────────────
interface PreferenceAction {
    val key: String
    val icon: ImageVector?
    val title: StringResource
    val description: StringResource?
}

// ── Shared contract for Radio + Choice — avoids unsafe casts in widgets ───────
interface PreferenceSelectableAction : PreferenceAction {
    val prefType: PreferenceType
    val currentValue: String?
    val options: Map<String, Any>
    val onItemSelected: ((key: String, value: Any) -> Unit)?
}

// ── Sealed base — exhaustive when, no accidental ordering bugs ────────────────
sealed class PreferenceItem : PreferenceAction

// ── Concrete types ────────────────────────────────────────────────────────────


data class PreferenceCategoryAction(
    override val key: String = "",
    override val icon: ImageVector? = null,
    override val title: StringResource,
    override val description: StringResource? = null,
) : PreferenceItem()


data class PreferenceButtonAction(
    override val key: String = "",
    override val icon: ImageVector? = null,
    override val title: StringResource,
    override val description: StringResource? = null,
    val url: String = "",        // ✅ replaces intentAction — used for QR + intent
    val onClick: () -> Unit,
) : PreferenceItem()


data class PreferenceSwitchAction(
    override val key: String,
    override val icon: ImageVector?,
    override val title: StringResource,
    override val description: StringResource,
    val currentValue: Boolean = false,
    val onCheckedChange: ((Boolean) -> Unit)?,
) : PreferenceItem()


data class PreferenceRadioAction(
    override val key: String,
    override val icon: ImageVector?,
    override val title: StringResource,
    override val description: StringResource,
    override val prefType: PreferenceType = PreferenceType.RADIO,
    override val currentValue: String? = null,
    override val options: Map<String, Any>,
    override val onItemSelected: ((key: String, value: Any) -> Unit)?,
) : PreferenceItem(), PreferenceSelectableAction  // ✅ implements shared contract


data class PreferenceChoiceAction(
    override val key: String,
    override val icon: ImageVector?,
    override val title: StringResource,
    override val description: StringResource?=null,
    override val prefType: PreferenceType = PreferenceType.CHOICE,
    override val currentValue: String? = null,
    override val options: Map<String, Any>,

    override val onItemSelected: ((key: String, value: Any) -> Unit)?,
) : PreferenceItem(), PreferenceSelectableAction  // ✅ implements shared contract

// ── Enum ──────────────────────────────────────────────────────────────────────
enum class PreferenceType {
    CONFIRMATION,
    RADIO,
    CHECKBOX,
    CHOICE,
}